import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { BASE_URL } from 'src/config/api.config';

// {
//   "CSC": 638,
//   "CSD": 599,
//   "DIACHI": "2A/6, Ấp Tân An, Xã Tân Hạnh - Huyện Long Hồ - Tỉnh Vĩnh Long",
//   "DINHMUC": 0,
//   "GIAMUC1": 8666.666666666666,
//   "GIAMUC2": 0,
//   "GIAMUC3": 0,
//   "HETNO": true,
//   "IDKH": "000001",
//   "KLTIEUTHU": 39,
//   "KOVAT": false,
//   "KYHD": "05/2023",
//   "KYHIEUHD": "1C23TAA",
//   "M3MUC1": 39,
//   "M3MUC2": 0,
//   "M3MUC3": 0,
//   "MABAOMAT": "000001052023",
//   "MADH": "009091",
//   "MAMDSD": "SH",
//   "MST": "",
//   "NAM": 2023,
//   "NGAYHD": "/Date(1690563600000+0700)/",
//   "SDT": "02703.821036 - 02703.863313",
//   "SOHD": "555",
//   "STT": null,
//   "TENKH": "CAO THANH PHONG",
//   "THANG": 5,
//   "TIENNUOC": 338000,
//   "TIENNUOCMUC1": 338000,
//   "TIENNUOCMUC2": 0,
//   "TIENNUOCMUC3": 0,
//   "TIENPHI": 0,
//   "TIENTHUE": 16900,
//   "TONGTIEN": 354900,
//   "TONGTIENTEXT": "Ba trăm năm mươi tư nghìn chín trăm  đồng"
// }

function GiayBao() {
  const componentRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [giayBaoInfo, setGiayBaoInfo] = useState(false);
  let { userId } = useParams();
  console.log(userId);

  const getInfo = async () => {
    try {
      const giayBaoInfo = await axios.get(
        `${BASE_URL}/web-api/public/GiayBao/${userId}`,
      );
      setGiayBaoInfo(giayBaoInfo.data.data);
      setIsLoading(false);
    } catch (error) {}
  };
  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div
      className="ml-3"
      style={{
        width: '700px',
        height: '100%',
        fontFamily: 'Times New Roman',
        marginLeft: '30px',
        marginTop: '25px',
      }}>
      <Row>
        {/* <Col className="col-2 text-center">
          <img src={logo} alt="" width={'100%'} className="mb-1"></img>
        </Col> */}
        <Col>
          <div className="mt-1">
            <b>CÔNG TY CỔ PHẦN NƯỚC VÀ MÔI TRƯỜNG BÌNH TÂN</b>
            <p>Mã số thuế: 1501012456</p>
            <p>Địa chỉ: 3530 Ấp Thành Phú, Xã Tân Quới, Tỉnh Vĩnh Long</p>
            <p>Điện thoại: 0270.3753368 - 0270.3550636</p>
          </div>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col className="text-center text-danger">
          <h1>
            <b>GIẤY BÁO TIỀN NƯỚC</b>
          </h1>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col className="col-3">TÊN KHÁCH HÀNG:</Col>
        <Col>{giayBaoInfo.TENKH}</Col>
      </Row>
      <Row className="mt-1">
        <Col className="col-2">ĐỊA CHỈ:</Col>
        <Col>{giayBaoInfo.DIACHI}</Col>
      </Row>
      <Row className="mt-1">
        <Col>MÃ KH:</Col>
        <Col>{giayBaoInfo.IDKH}</Col>
        <Col>Loại sử dụng:</Col>
        <Col>{giayBaoInfo.MAMDSD}</Col>
        <Col>Kỳ hoá đơn:</Col>
        <Col>{giayBaoInfo.KYHD}</Col>
      </Row>
      <Row className="mt-1">
        <Col>Ký hiệu HĐ:</Col>
        <Col className="text-danger">
          <b>{giayBaoInfo.KYHIEUHD}</b>
        </Col>
        <Col>Số HĐ:</Col>
        <Col className="text-danger">
          <b>{giayBaoInfo.SOHD}</b>
        </Col>
        <Col>Ngày xuất HĐ:</Col>
        <Col className="text-danger">
          <b>{giayBaoInfo.NGAYHD}</b>
        </Col>
      </Row>
      <Row className="mt-5">
        <table style={{ border: '1px solid black' }}>
          <tr>
            <td className="text-center" style={{ border: '1px solid black' }}>
              <b>Chỉ số cũ</b>
            </td>
            <td className="text-center" style={{ border: '1px solid black' }}>
              <b>Chỉ số mới</b>
            </td>
            <td className="text-center" style={{ border: '1px solid black' }}>
              <b>Khối lượng tiêu thụ</b>
            </td>
          </tr>
          <tr>
            <td className="text-center" style={{ border: '1px solid black' }}>
              {giayBaoInfo.CSD}
            </td>
            <td className="text-center" style={{ border: '1px solid black' }}>
              {giayBaoInfo.CSC}
            </td>
            <td className="text-center" style={{ border: '1px solid black' }}>
              {giayBaoInfo.KLTIEUTHU}
            </td>
          </tr>
          <tr>
            <td className="text-center" style={{ border: '1px solid black' }}>
              <b>Mức sử dụng</b>
            </td>
            <td className="text-center" style={{ border: '1px solid black' }}>
              <b>Đơn giá</b>
            </td>
            <td className="text-center" style={{ border: '1px solid black' }}>
              <b>Thành tiền</b>
            </td>
          </tr>
          {/* --------------------------------- */}
          {giayBaoInfo.M3MUC1 !== 0 && (
            <tr>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.M3MUC1}
              </td>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.GIAMUC1}
              </td>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.TIENNUOCMUC1}
              </td>
            </tr>
          )}
          {giayBaoInfo.M3MUC2 !== 0 && (
            <tr>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.M3MUC2}
              </td>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.GIAMUC2}
              </td>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.TIENNUOCMUC2}
              </td>
            </tr>
          )}
          {giayBaoInfo.M3MUC3 !== 0 && (
            <tr>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.M3MUC3}
              </td>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.GIAMUC3}
              </td>
              <td className="text-center" style={{ border: '1px solid black' }}>
                {giayBaoInfo.TIENNUOCMUC3}
              </td>
            </tr>
          )}
          {/* --------------------------------- */}
          <tr>
            <td
              className="text-left"
              colSpan={2}
              style={{ border: '1px solid black' }}>
              <b>A.Tiền nước (chưa thuế GTGT)</b>
            </td>
            <td
              className="text-right"
              style={{
                border: '1px solid black',
                textAlign: 'right',
                paddingRight: '5px',
              }}>
              <b>{giayBaoInfo.TIENNUOC}</b>
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan={2}
              style={{ border: '1px solid black' }}>
              <b> B. Tiền thuế GTGT: 5%</b>
            </td>
            <td
              className="text-right"
              style={{
                border: '1px solid black',
                textAlign: 'right',
                paddingRight: '5px',
              }}>
              <b>{giayBaoInfo.TIENTHUE}</b>
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan={2}
              style={{ border: '1px solid black' }}>
              <b>C.Phí môi trường: 10%</b>
            </td>
            <td
              className="text-right"
              style={{
                border: '1px solid black',
                textAlign: 'right',
                paddingRight: '5px',
              }}>
              <b>{giayBaoInfo.TIENPHI}</b>
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan={2}
              style={{ border: '1px solid black' }}>
              <b> D.Các khoản khác:</b>
            </td>
            <td
              className="text-right"
              style={{
                border: '1px solid black',
                textAlign: 'right',
                paddingRight: '5px',
              }}>
              <b>0</b>
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan={2}
              style={{ border: '1px solid black' }}>
              <b>E.Tổng tiền thanh toán (A+B+C+D):</b>
            </td>
            <td
              className="text-right"
              style={{
                border: '1px solid black',
                textAlign: 'right',
                paddingRight: '5px',
              }}>
              <b>{giayBaoInfo.TONGTIEN}</b>
            </td>
          </tr>
          <tr>
            <td
              className="text-left text-danger"
              colSpan={3}
              style={{ border: '1px solid black' }}>
              <b>Số tiền bằng chữ: {giayBaoInfo.TONGTIENTEXT}</b>
            </td>
          </tr>
        </table>
      </Row>
    </div>
  );
}

export default GiayBao;
